<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  let statusList = {0:"停用",1:"启用"}
  let channeList = {}
  let platformList = {"android":"Android","ios":"IOS"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if("delete" == clickName){
          this.dataChanage(URL.app.appversion.delete,{id:row.id},res =>{
            if (res.code == 0){
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
            this.$refs.childTable.defaultGetData(this.queryData);
          });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if(window.$t('txmis.bt.search') == clickName || "查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if(window.$t('txmis.bt.add') == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.app.appversion.edit,model,res => {
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
              this.$message.error(res.message);
          }
          this.$refs.childTable.defaultGetData(this.queryData);
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    created() {
      this.$axios.get(URL.advertising.getData).then(res=> {
        if (res.code == 0) {
          channeList = res.result.dfre;
          this.updateData.cols =
          [
            { title: 'id', field: 'id',hidden:true},
            { title: '平台', field: 'platform',type: 2,optionList: platformList,required: true},
            { title: '渠道', field: 'channel',type: 3,optionList: channeList,required: true},
            { title: '版本号', field: 'version',required: true,type: 7},
            { title: '版本名称', field: 'versionName',required: true},
            { title: '更新链接', field: 'url',required: true},
            { title: '状态', field: 'status',type: 2,optionList: statusList,isNumber: true,data: 1,required: true},
            { title: '升级说明(英文)', field: 'content',textType: 'textarea',required: true},
            { title: '升级说明(越南)', field: 'contentVn',textType: 'textarea'},
            { title: '升级说明(印度)', field: 'contentHi',textType: 'textarea'},
            { title: '升级说明(繁体)', field: 'contentTc',textType: 'textarea'},
          ]
        }
      });

    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
            cols:[]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: '平台', field: 'platform',type: 2,optionList: platformList},
              { title: '渠道', field: 'channel'},
              {click:window.$t('txmis.bt.search')},
              {click:window.$t('txmis.bt.add')},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.app.appversion.list, //请求路径和参数
          sequence: true,
          cols: [
              { title: '平台', field: 'platform'},
              { title: '渠道', field: 'channel'},
              { title: '版本号', field: 'version'},
              { title: '版本名称', field: 'versionName'},
              { title: '更新链接', field: 'url'},
              { title: '状态', field: 'status',render:(data,full)=>{
                return statusList[data];
                }},
              { title: '更新时间', field: 'updateTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '更新人', field: 'updater'},
              {title: window.$t('txmis.bt.operation'),width: 200,btnClick:[
                {name: window.$t('txmis.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit"},
                {name: window.$t('txmis.bt.delete'),click:"delete",type:"primary",icon:"el-icon-edit"},
              ]
            },
          ]
        }
      }
    }
  }
</script>
